import { Component, ViewChild, NgZone } from "@angular/core";
import { ModalDirective } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import {
  ToastrService,
  ProjectService,
  Project,
  GlobalService,
  LoggingService,
} from "./../../../../shared/index";

@Component({
  selector: "staging-tabs",
  templateUrl: "./staging-tabs.component.html",
  standalone: false,
})
export class StagingTabsComponent {
  live = true;
  Project_Name: string;
  Is_Add = true;
  Project_ID: number;
  Is_Projects_View = false;
  Is_Project_Selected = false;
  public project: Project[] = [];
  public StagingStatus: any;
  CanUnlocked = false;
  IsLocked: boolean;
  IsEnabledPublihed: boolean;
  Note: string;
  loading = false;
  private subscriptions: Subscription[] = [];
  @ViewChild("createProjectModal") createProjectModal: ModalDirective;
  @ViewChild("ResetChanges") ResetChanges: ModalDirective;
  @ViewChild("ResetChangesAndForcedUnlock")
  ResetChangesAndForcedUnlock: ModalDirective;
  @ViewChild("PublishChanges") PublishChanges: ModalDirective;
  SelectedProject: number;
  constructor(
    private _ProjectService: ProjectService,
    private _ToastrService: ToastrService,
    private _globalService: GlobalService,
    private _ngZone: NgZone,
    private _loggingService: LoggingService
  ) {
    this.Is_Projects_View = false;
  }
  ngOnInit() {
    this.Note = "";
    this.IsLocked = false;
    this.IsEnabledPublihed = false;
    this.SelectedProject = 0;
    this.live = true;
    this.GetStagingTabStatus();
    this._globalService.SetEnvironmentLocked.subscribe((Status) => {
      if (Status === "1") this.LockStagingTabFromAnyAction();
    });
  }

  GetStagingTabStatus() {
    this.Note = "";
    this.CanUnlocked = false;
    this.IsLocked = false;
    this.IsEnabledPublihed = false;
    localStorage.removeItem("Lock");
    localStorage.removeItem("Msg");
    this.StagingStatus = {};
    return this._ProjectService
      .GetStagingTabStatus(this.live)
      .then((result: any) => {
        this._ngZone.run(() => {
          if (result != null) {
            this.StagingStatus = result;
            this.CanUnlocked = this.StagingStatus.CanUnlocked;
            this.IsLocked = this.StagingStatus.IsLocked;
            if (!this.IsLocked) {
              this.CanUnlocked = false;
            }
            if (this.IsLocked && this.StagingStatus.IsMain) {
              if (
                Number(this.StagingStatus.LockedBy) !==
                  Number(localStorage.getItem("User_ID")) &&
                this.IsLocked
              ) {
                localStorage.setItem("Lock", "1");
              } else {
                localStorage.setItem("Lock", "10");
              }
              this.Note = this.StagingStatus.Note;
              if (
                Number(this.StagingStatus.LockedBy) ===
                Number(localStorage.getItem("User_ID"))
              ) {
                this.IsEnabledPublihed = true;
                this.Note = "Locked by you";
                this.CanUnlocked = false;
              }
              localStorage.setItem("Msg", this.Note);
            }
          }
        });
      });
  }
  changeStage(value: boolean) {
    this.live = value;
    this.GetStagingTabStatus();
  }
  cancelAdd() {
    this.createProjectModal.hide();
  }
  Create_Project() {
    //this doesn't get hit
    //seems some other function is being called
    //added this here so typescript would stop complaining
  }
  public edit(val: Project): void {
    this.Is_Add = false;
    this.Project_ID = val.Project_ID;
    this.Project_Name = val.Project_Title;
  }

  public ResetConfirmation(): void {
    this.ResetChanges.show();
  }
  public ResetConfirmationForcedUnlock(): void {
    this.ResetChangesAndForcedUnlock.show();
  }

  public Reset() {
    return this._ProjectService.delete().then((result: any) => {
      if (result) {
        this.ResetChanges.hide();
        this._ToastrService.displayToastrMessage(
          "success",
          "Staging changes discarded successfully",
          "Success!"
        );
      } else {
        this._ToastrService.displayToastrMessage(
          "error",
          "Error occured while processing your request",
          "Publish Changes!"
        );
      }
    });
  }
  public ResetAndForcedUnlocked() {
    return this._ProjectService
      .Reset_Staging_Environment_Forced_Unlock()
      .then((result: any) => {
        if (result) {
          this.ResetChangesAndForcedUnlock.hide();
          this._ToastrService.displayToastrMessage(
            "success",
            "Staging changes discarded successfully",
            "Success!"
          );
          this.GetStagingTabStatus();
        } else {
          this._ToastrService.displayToastrMessage(
            "error",
            "Error occured while processing your request",
            "Publish Changes!"
          );
        }
      });
  }

  public PublishConfirmation(): void {
    this._loggingService.log("Show Publish Confirmation");
    this.PublishChanges.show();
  }
  public PublishProject() {
    this._loggingService.log("Publish Project Initiated");
    this.loading = true;
    return this._ProjectService
      .Publish_Project_Details()
      .then((result: any) => {
        if (result) {
          this._loggingService.log("Publish Project Result:", result);
          this._ToastrService.displayToastrMessage(
            "success",
            "Changes published successfully",
            "Publish Changes!"
          );
          this.PublishChanges.hide();
          //this.Get_All_Projects_With_Details();
        } else {
          this._ToastrService.displayToastrMessage(
            "error",
            "Error occured while processing your request",
            "Publish Changes!"
          );
        }
        this.loading = false;
      });
  }
  Close() {
    this.ResetChanges.hide();
    this.PublishChanges.hide();
  }
  public GetSelectedProject(val: any): void {
    localStorage.removeItem("P_ID");
    localStorage.setItem("P_ID", val);
    if (val == "0") {
      this.Is_Project_Selected = false;
    } else {
      this.Is_Project_Selected = true;
    }
    this._ProjectService.Get_Company_Under_Project(val);
  }
  LockStagingTab() {
    this._ProjectService.LockStagingTab().then((result: any) => {
      if (result != null) {
        if (result.IsLocked) {
          if (result.LockedBy != Number(localStorage.getItem("User_ID"))) {
            this._ToastrService.displayToastrMessage(
              "error",
              result.Note,
              "Staging environment Status!"
            );
          } else {
            this._ToastrService.displayToastrMessage(
              "success",
              "Environment is locked successfully",
              "Staging environment Status!"
            );
          }
        }
        this.GetStagingTabStatus();
      }
    });
  }
  LockStagingTabFromAnyAction() {
    this.GetStagingTabStatus();
  }
}
